// extracted by mini-css-extract-plugin
export default {"AppBar":"appBar_AppBar__mTx4X"};